// extracted by mini-css-extract-plugin
export var chevron = "_jv-3";
export var chevronRotated = "_jv-4";
export var image = "_jv-1";
export var imageContainer = "_jv-0";
export var shippingAddress = "_jv-2";